var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0601 12.2855L15.2488 10.8016C14.0671 9.8353 12.2386 9.92589 11.1604 11.0043L11.0871 11.0776C10.9059 11.2588 10.6127 11.2588 10.4359 11.0776L6.93831 7.57924C6.76149 7.40238 6.75718 7.11768 6.92968 6.9365C6.934 6.93219 6.934 6.92787 6.93831 6.92787L6.92968 6.9365C6.934 6.93219 6.934 6.93219 6.93831 6.92787C8.00785 5.84514 8.11135 4.00751 7.17551 2.82124L5.70489 0.962043C4.75611 -0.232848 3.1173 -0.327749 2.03914 0.750673L1.76744 1.02244C-0.138751 2.9334 -0.59158 6.38004 0.844533 8.6706C0.844533 8.6706 1.68981 10.629 4.53616 13.4761C7.38251 16.3231 9.34046 17.1686 9.34046 17.1686C11.652 18.5662 15.0763 18.1521 16.9868 16.2411L17.2455 15.9823C18.3194 14.9082 18.2375 13.2517 17.0601 12.2855ZM15.9431 14.6839L15.6844 14.9427C14.3733 16.2541 11.8806 16.556 10.2936 15.5941L10.1857 15.5294L10.0693 15.4776C9.92698 15.4172 9.56903 15.2231 9.02995 14.8607C8.07254 14.218 6.99437 13.3337 5.83427 12.1733C4.67417 11.0129 3.79007 9.93883 3.14749 8.98119C2.78523 8.44198 2.59116 8.08394 2.53078 7.94159L2.47472 7.81218L2.4014 7.6914C1.43537 6.15141 1.75019 3.64516 3.06986 2.32086L3.34156 2.04909C3.63913 1.75145 3.99708 1.7687 4.26015 2.10086L5.73077 3.96006C6.09303 4.41731 6.04559 5.21534 5.62726 5.63377C4.73886 6.53533 4.74317 7.98473 5.63589 8.87766L9.13345 12.3761C10.0305 13.2733 11.4882 13.2733 12.3895 12.3761L12.4628 12.3027C12.8725 11.8929 13.6359 11.8584 14.0844 12.2251L15.8957 13.709C16.2321 13.9851 16.2493 14.3776 15.9431 14.6839Z",
    fill: "url(#paint0_linear_1_8693)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_8693",
    x1: 0.000771539,
    y1: 7.87345,
    x2: 18.0006,
    y2: 7.87345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16);
export default __webpack_public_path__ + "static/media/icon-16.7ee5b0e732b7c89311c1b18fc6c08869.svg";
export { ForwardRef as ReactComponent };